export interface VoicebotSortOption {
    label: string
    value: string
    prop: string
    order: string
}

export function getVoicebotSortOptions (t: (key: string) => string): VoicebotSortOption[] {
    return [
        {
            label: `${t('extensions.sort.userName.asc')} - ${t('sorting.asc')}`,
            value: 'VoicebotName-asc',
            prop: 'VoicebotName',
            order: 'asc'
        },
        {
            label: `${t('extensions.sort.userName.desc')} - ${t('sorting.desc')}`,
            value: 'VoicebotName-desc',
            prop: 'VoicebotName',
            order: 'desc'
        },
        {
            label: `${t('extensions.sort.callDuration.asc')} - ${t('sorting.asc')}`,
            value: 'callDuration-asc',
            prop: 'callDuration',
            order: 'asc'
        },
        {
            label: `${t('extensions.sort.callDuration.desc')} - ${t('sorting.desc')}`,
            value: 'callDuration-desc',
            prop: 'callDuration',
            order: 'desc'
        },
    ]
}
